// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { voltageDropCalculatorStyles } from "@awc/App/Widgets/VoltageDropCalculator/VoltageDropCaculator";
import { color, sharedCustomerToolsTableStyles, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

voltageDropCalculatorStyles.textFieldAndUnitWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 6px;
    `,
};
voltageDropCalculatorStyles.loadTextField =
    voltageDropCalculatorStyles.conductorTextField =
    voltageDropCalculatorStyles.cableLengthTextField =
    voltageDropCalculatorStyles.estimatedVoltageTextField =
    voltageDropCalculatorStyles.voltageDropPercentageTextField =
    voltageDropCalculatorStyles.phaseSelect =
    voltageDropCalculatorStyles.sizeSelect =
    voltageDropCalculatorStyles.materialSelect =
        {
            cssOverrides: {
                formInputWrapper: css`
                    max-width: 300px;
                `,
            },
        };

voltageDropCalculatorStyles.table = {
    css: css`
        ${sharedCustomerToolsTableStyles.css}
        &&& td {
            white-space: normal;
            > label,
            > div > span {
                color: ${color("common.ui29")};
            }
        }
        ${xScreen("lte", "sm")} {
            max-width: 100%;
        }
    `,
};

voltageDropCalculatorStyles.calculateButton = {
    css: css`
        margin-left: auto;
        margin-right: auto;
    `,
};
